import React from "react";
import LegalLayout, { LEGAL_ENTITY } from "../../components/LegalLayout";

export default function ShippingReturnsPage() {
  const sections = [
    {
      heading: "Livrare în România",
      body: [
        "Toate comenzile VIS DE ZI se expediază din România prin curier rapid (Fan Courier sau Sameday, în funcție de localitate).",
        "Timp de procesare: 1 zi lucrătoare de la plasarea comenzii. Pentru comenzile plasate vineri după ora 14:00, sâmbăta sau duminica, procesarea începe în prima zi lucrătoare următoare.",
        "Timp de livrare: 24-48 ore lucrătoare după expediere, în toată țara.",
      ],
    },
    {
      heading: "Cost livrare",
      body: [
        "Curier la domiciliu: 20 RON pentru orice comandă sub 150 RON.",
        "Easybox Sameday și FanBox Fan Courier: 15 RON pentru orice comandă sub 150 RON.",
        "Livrare gratuită pentru comenzile de peste 150 RON — un cadou blând din partea noastră.",
      ],
    },
    {
      heading: "Metodă de plată",
      body: [
        "Momentan acceptăm plata ramburs la curier — plătești în numerar direct la primirea coletului, sau cu cardul la Easybox sau FanBox.",
        "Plata online cu cardul va fi disponibilă în curând.",
      ],
    },
  ];

  return (
    <LegalLayout
      eyebrow="Informații utile"
      title="Livrare"
      lastUpdated="1 octombrie 2026"
      sections={sections}
      legalEntity={LEGAL_ENTITY}
    />
  );
}
